
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { Heading, Row } from '@warrenbrasil/nebraska-web';
import { TransactionModal } from '@/modules/transaction/components/TransactionModal';
import {
  EGlobalTransactionMovement,
  GlobalTransaction
} from '@/modules/common/services/graphql/server/server.sdk';
import { hasDetails } from '@/modules/transaction/helpers/transaction';
import { WarrenModules } from '@/types/navigation';
import { GlobalTransactionAmount } from '@/modules/transaction/components/GlobalTransactionAmount';
import { GlobalTransactionStatus } from '@/modules/transaction/components/GlobalTransactionStatus';
import { Money } from '@/modules/common/components/Money';
import { Portal } from '@/modules/common/components/Portal';
import {
  trackTransactionDetails,
  trackTransactionsPageNavigation
} from '@/modules/transaction/helpers/transactions-events';
import { FeatureFlags } from '@/types/models/FeatureFlags';
import { FeatureFlagsModule } from '@/modules/common/store/FeatureFlagsModule';

@Component({
  components: {
    Heading,
    Row,
    TransactionModal,
    GlobalTransactionAmount,
    GlobalTransactionStatus,
    Money,
    Portal
  }
})
export default class GlobalTransactionsSummary extends Vue {
  public transactionId?: string = '';
  public transactionType?: string = '';
  public showModal = false;

  @Prop({ type: Array, required: true, default: () => [] })
  public transactions!: GlobalTransaction[];

  @Prop({ type: String, required: true })
  public module!: WarrenModules;

  @Prop({ type: String, required: false })
  public title?: string;

  @Prop({ type: String, default: 'Não há movimentações.' })
  public emptyTransactionsMessage!: string;

  @Prop({ type: String, required: false })
  public portfolioId?: string;

  @Prop({ type: String, default: 'Ver mais' })
  public loadMoreLabel?: string;

  @Emit()
  public trackTransactionDetails(name?: string) {
    return name;
  }

  @Emit()
  public trackTransactionsPageNavigation() {}

  @Emit()
  public cancelTransaction() {}

  public get parsedTransactions() {
    return this.transactions.map(transaction => ({
      ...transaction,
      isCanceled:
        transaction.movement!.value === EGlobalTransactionMovement.Canceled,
      hasDetails: hasDetails(transaction.type!.value, transaction.status!.value) // TODO: use transaction.hasDetails from API
    }));
  }

  public onClickTransaction(transaction: GlobalTransaction) {
    this.transactionId = transaction.id;
    this.transactionType = transaction.typeV2!.value;
    this.showModal = true;

    trackTransactionDetails(this.module, transaction.type?.value);
    this.trackTransactionDetails(transaction.type?.formatted);
  }

  public redirectToTransactionsPage() {
    const query: Record<string, string> = {};
    if (this.module === WarrenModules.Wealth) {
      if (this.portfolioId) {
        query.portfolioId = this.portfolioId;
      }

      if (this.isUnifiedAccountEnabled) {
        this.$router.push({ name: 'wealthOrders', query });
      } else {
        query.module = this.module;
        this.$router.push({ name: 'transactions', query });
      }
    } else {
      query.module = this.module;
      this.$router.push({ name: 'transactions', query });
    }

    trackTransactionsPageNavigation(this.module);
    this.trackTransactionsPageNavigation();
  }

  get isUnifiedAccountEnabled() {
    return FeatureFlagsModule.isEnabled(FeatureFlags.UNIFIED_ACCOUNT);
  }

  public closeModal() {
    this.transactionId = '';
    this.transactionType = '';
    this.showModal = false;
    this.emitReloadHomeTransactions();
  }

  @Emit('reload-transactions')
  emitReloadHomeTransactions() {}

  public get hasTransactions() {
    return this.transactions && this.transactions?.length > 0;
  }
}
